function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M15.713 91h35v9h-35z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M16.213 91.5h34v8h-34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M19.174 88l-7.417 54H6.713l3.461-54z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M18.601 88.5h-7.958l-3.397 53h4.075l7.28-53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M9.918 87.251L.713 22H5.87l13.27 65.251z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M10.352 86.751h8.176L5.46 22.5H1.288l9.064 64.251z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M55.713 88v54H50.18l-3.467-54z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M55.213 88.5h-7.967l3.403 53h4.564v-53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M11.713 85H56a4 4 0 014 4v3H7.713v-3a4 4 0 014-4z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M8.213 91.5H59.5V89a3.5 3.5 0 00-3.5-3.5H11.713a3.5 3.5 0 00-3.5 3.5v2.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M173 91h-35v9h35z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M172.5 91.5h-34v8h34z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M169.538 88l7.418 54H182l-3.462-54z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M170.111 88.5h7.958l3.397 53h-4.074l-7.28-53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M178.305 87l9.205-65.251h-5.157L169.083 87z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M177.87 86.5h-8.175l13.067-64.251h4.173L177.87 86.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M133.098 88v54h5.533l3.467-54z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M133.598 88.5h7.967l-3.403 53h-4.564v-53z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M177 85h-44.287a4 4 0 00-4 4v3H181v-3a4 4 0 00-4-4z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M180.5 91.5h-51.287V89a3.5 3.5 0 013.5-3.5H177a3.5 3.5 0 013.5 3.5v2.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M119.39 27.582c2.388-.64 4.888-2.545 7.502-5.716-3.849-1.44-6.967-1.84-9.354-1.2-3.58.96-4.123 2.764-3.612 4.674.512 1.91 1.884 3.2 5.465 2.242z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M126.048 22.092c-3.451-1.207-6.247-1.514-8.38-.943-2.953.792-3.787 2.091-3.259 4.062.528 1.97 1.9 2.679 4.852 1.888 2.134-.572 4.402-2.236 6.787-5.007z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M116.232 15.175c-.947-2.032-3.044-3.966-6.289-5.802-.68 3.666-.545 6.515.402 8.547 1.422 3.048 3.12 3.25 4.745 2.491 1.626-.758 2.564-2.188 1.142-5.236z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M110.313 10.166c-.52 3.233-.351 5.748.485 7.543 1.162 2.491 2.428 3.02 4.081 2.249 1.653-.77 2.062-2.08.9-4.572-.837-1.794-2.655-3.54-5.466-5.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M127.5 13c-7.456 0-13.5 9.626-13.5 21.5 0 .167-3-.165-3-.5 0-8.805 3.095-16.546 7.772-21h8.728z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M123.298 13.5h-4.324c-4.57 4.45-7.413 11.97-7.473 20.232.03.01.062.019.098.028.243.065.588.13.97.183.334.046.672.08.934.094.126-9.633 4.176-17.78 9.795-20.537zM111.5 33.982a35.6 35.6 0 00-.002-.033z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M132.623 4.895l-1.765 3.646 2.876-1.151c.115 1.338-.489 2.792-1.801 4.599-2.99 4.113-8.594 6.164-11.917 3.75-3.323-2.414-3.104-8.379-.116-12.492 1.634-2.248 3.087-3.284 4.8-3.23l-.843 3.185 3.61-2.329c.299.158.607.336.926.536l-1.098 4.29 3.742-2.37c.644.537 1.172 1.054 1.586 1.566z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M132.031 4.969a11.17 11.17 0 00-1.038-1.021l-4.495 2.848 1.32-5.153c-.112-.066-.221-.129-.329-.19l-4.445 2.868.995-3.762c-1.231.203-2.388 1.13-3.734 2.982-2.937 4.042-2.968 9.634.005 11.794s8.282.402 11.218-3.64c1.03-1.417 1.574-2.56 1.694-3.562l-3.377 1.352 2.186-4.516z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M99.105 32h27.049c.07.837.105 1.69.105 2.556 0 11.29-6.102 20.444-13.63 20.444C105.103 55 99 45.847 99 34.556c0-.866.036-1.719.105-2.556z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M99.57 32.5a30.45 30.45 0 00-.07 2.056c0 11.047 5.931 19.944 13.13 19.944 7.198 0 13.13-8.897 13.13-19.944 0-.69-.024-1.376-.07-2.056H99.57z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M73 55h75v12H73z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M73.5 55.5h74v11h-74z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M67 52.499h11.488L72.157 142H67z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M67.5 52.999V141.5h4.191l6.26-88.501H67.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M153 52.499V142h-5.249l-5.211-89.501z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M152.5 52.999h-9.43l5.153 88.501h4.277V52.999z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#D7D7D7",
  d: "M53 50h113v7H53z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#F4F4F4",
  d: "M53.5 50.5h112v6h-112z"
})));

function SvgRoomSceneryDiningSet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188,
    height: 142,
    viewBox: "0 0 188 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryDiningSet);
export default __webpack_public_path__ + "static/media/RoomSceneryDiningSet.1b0d1325.svg";
export { ForwardRef as ReactComponent };